import { experimentsService } from '@wix/cashier-common/dist/src/utils/experimentsService';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './components/App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { type BaseConfig } from './types/Config';
import { initAppErrorReporter } from './utils/errorReporter';
import { extractVersionFromBaseUrl } from './utils/staticsBaseUrlUtils';

const baseConfig: BaseConfig = window.__BASE_CONFIG__;

experimentsService.init(window.__EXPERIMENTS__ || {});

initAppErrorReporter({
  userId: baseConfig.visitorId,
  locale: baseConfig.locale,
  providerId: baseConfig.providerId,
  msid: baseConfig.msid,
  version: extractVersionFromBaseUrl(window.__STATICS_BASE_URL__),
});

const root = createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary parentOrigin={baseConfig.parentOrigin}>
    <App {...baseConfig} l10n={window.__L10N__} />
  </ErrorBoundary>,
);
